<template>
  <div>
    <v-container>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-container>

    <v-data-table
      :items="orders"
      :search="search"
      :pagination.sync="pagination"
      :expand="expand"
      :headers="mainTableHeaders"
      :loading="loading"
      item-key="orderID"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

      <template v-slot:items="props">
        <tr>
          <td
            class="primary title"
            style="color: white;"
            width="15%"
            @click="props.expanded = !props.expanded"
          >Order {{props.item.orderID}}</td>
          <td
            class="primary title"
            style="color: white;"
            width="20%"
            @click="props.expanded = !props.expanded"
          >{{props.item.customerName}}</td>
          <td
            class="primary title"
            style="color: white;"
            width="45%"
            @click="props.expanded = !props.expanded"
          >{{props.item.ubAccountID}}</td>
          <td class="primary title" style="color: white;" width="20%">
            <v-progress-circular v-if="sending" indeterminate color="white"></v-progress-circular>
            <v-btn v-else class="secondary" @click.native="send(props.item)">Send to Grenke</v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-flex xs12>
          <AdminSubTable
            :extensions="orders.find(x=>x.orderID == props.item.orderID).ipExtensions"
            @settoEdited="setOrderToEdited"
          ></AdminSubTable>
        </v-flex>
      </template>
      <template v-slot:no-results>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </template>
    </v-data-table>
    <v-flex xs12>
      <v-spacer></v-spacer>
      <v-btn class="primary" @click.native="save">Save</v-btn>
    </v-flex>

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>

    <v-alert :value="true" type="error" v-if="errorList.length>0">
      Errors:
      <ul>
        <li v-for="err in errorList">{{err}}</li>
      </ul>
    </v-alert>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
import AdminSubTable from "../components/qantas/admin-subtable";
export default {
  name: "QantasAdmin",
  components: {
    AdminSubTable
  },
  data() {
    return {
      search: "",
      expand: true,
      loading: false,
      sending: false,
      snack: false,
      snackColor: "",
      snackText: "",
      timeTest: null,
      errorList: [],
      pagination: {},
      mainTableHeaders: [
        {
          text: "Order ID",
          align: "left",
          sortable: true,
          value: "orderID"
        },
        {
          text: "Customer Name",
          align: "left",
          sortable: true,
          value: "customerName"
        },
        {
          text: "Account No",
          align: "left",
          sortable: true,
          value: "ubAccountNo"
        }
      ],
      orders: []
    };
  },
  mounted() {
    let vm = this;
    vm.loading = true;
    vm.getAdminRows().then(result => {
      if (result) {
        vm.orders = result;
      }
      vm.loading = false;
    });
  },
  methods: {
    ...mapOrderActions(["getAdminRows", "updateAdminRows", "sendUpdatedMacs"]),
    setOrderToEdited(item) {
      let vm = this;
      let index = vm.orders.findIndex(x => x.orderID === item.orderID);
      vm.orders[index].edited = true;
      vm.errorList = vm.errors.all();
    },
    save() {
      let vm = this;

      let editedRows = vm.orders.filter(x => x.edited == true);

      //Manual validation
      vm.errorList = [];
      if (editedRows.length == 0) {
        this.snack = true;
        this.snackColor = "info";
        this.snackText = "No edits have been made.";
      } else {
        editedRows.forEach(element => {
          element.ipExtensions.forEach(element => {
            if (!element.macAddress || element.macAddress === undefined)
              vm.errorList.push(
                `The Mac Address for Extension ${element.extensionNo} of Order ${element.orderID} is empty`
              );

            if (
              !element.grenkeFinanceNo ||
              element.grenkeFinanceNo === undefined
            )
              vm.errorList.push(
                `The  Grenke Finance Number for Extension ${element.extensionNo} of Order ${element.orderID} is empty`
              );

            if (
              element.extensionNo &&
              !Number.isInteger(Number.parseInt(element.extensionNo))
            )
              vm.errorList.push(
                `The Extension Number for Extension ${element.extensionNo} of Order ${element.orderID} is not a number`
              );
          });
        });

        if (vm.errorList.length == 0) {
          vm.updateAdminRows(editedRows).then(result => {
            if (result) {
              this.snack = true;
              this.snackColor = "success";
              this.snackText = "Data saved";
            }
          });
        } else {
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "Please address the errors";
        }
      }
    },
    send(element) {
      let vm = this;

      vm.errorList = [];
      element.ipExtensions.forEach(element => {
        if (!element.macAddress || element.macAddress === undefined)
          vm.errorList.push(
            `The Mac Address for Extension ${element.extensionNo} of Order ${element.orderID} is empty`
          );

        if (!element.grenkeFinanceNo || element.grenkeFinanceNo === undefined)
          vm.errorList.push(
            `The  Grenke Finance Number for Extension ${element.extensionNo} of Order ${element.orderID} is empty`
          );

        if (
          element.extensionNo &&
          !Number.isInteger(Number.parseInt(element.extensionNo))
        )
          vm.errorList.push(
            `The Extension Number for Extension ${element.extensionNo} of Order ${element.orderID} is not a number`
          );
      });
      if (vm.errorList.length == 0) {
        vm.sending = true;
        vm.sendUpdatedMacs(element).then(result => {
          if (result) {
            vm.sending = false;
            this.snack = true;
            this.snackColor = "success";
            this.snackText = "Details have been sent to Grenke";
          }
        });
      }
    }
  }
};
</script>